module.exports = __webpack_public_path__ + "static/media/Logo-ferme-pelissou.ed7ecef3.svg";